let requestedThisSession = false;

/**
 * Best-effort request for persistent storage so OPFS/IndexedDB data is less likely to be evicted.
 * Safe to call many times; it will only attempt once per page session.
 */
export async function requestPersistentStorageOnce(reason: string): Promise<boolean> {
  if (requestedThisSession) return false;
  requestedThisSession = true;

  try {
    const storage: any = (navigator as any)?.storage;
    if (!storage || typeof storage.persist !== 'function') return false;

    try {
      if (typeof storage.persisted === 'function') {
        const already = await storage.persisted();
        if (already) return true;
      }
    } catch {
      // ignore
    }

    const granted = await storage.persist();
    console.log(`[storage] persistent=${granted} (${reason})`);
    return !!granted;
  } catch (e) {
    console.warn('[storage] persist() failed', e);
    return false;
  }
}

